import { ServiceResponse } from "../ServiceResponse";

export class SendUsernameResponse extends ServiceResponse {
    public UserExists: boolean = false;
}
